import { render, staticRenderFns } from "./cdbUsage.vue?vue&type=template&id=1227fc20&scoped=true"
import script from "./cdbUsage.vue?vue&type=script&lang=js"
export * from "./cdbUsage.vue?vue&type=script&lang=js"
import style0 from "./cdbUsage.vue?vue&type=style&index=0&id=1227fc20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1227fc20",
  null
  
)

export default component.exports